import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from '@mui/material/Link';
import Alert from '@mui/material/Alert';
var LoggedOut = function () { return (_jsxs(Alert, { severity: "success", sx: { justifyContent: 'center' }, children: ["You're logged out. Please ", _jsx(Link, { href: "/", children: "click here" }), " to log back in"] })); };
export default LoggedOut;
